import {
  OrderIdentifierColumnType,
  ShipmentsSortField,
} from "@api/graphql/generated/generated-types";
import { getOrderIdentifierColumnTitle } from "../utils/orderIdentifierColumn";

export interface TableColumnType {
  title: string;
  dataIndex: string | undefined;
  key: string;
  sortFields?: string[];
}

export function getShipmentTableColumns(
  orderIdentifierColumnType: OrderIdentifierColumnType,
): TableColumnType[] {
  return [
    {
      title: getOrderIdentifierColumnTitle(orderIdentifierColumnType),
      dataIndex: "order",
      key: "order",
      sortFields: [ShipmentsSortField.OrderDisplayId],
    },
    {
      title: "Customer",
      dataIndex: "customers",
      key: "customers",
      sortFields: [ShipmentsSortField.EndCustomerName],
    },
    {
      title: "Origin",
      dataIndex: "pickup",
      key: "pickup",
      sortFields: [
        ShipmentsSortField.OriginDispatchZone,
        ShipmentsSortField.PickUpCompanyName,
      ],
    },
    {
      title: "Destination",
      dataIndex: "dropoff",
      key: "dropoff",
      sortFields: [
        ShipmentsSortField.DestinationDispatchZone,
        ShipmentsSortField.DropOffCompanyName,
      ],
    },
    {
      title: "Ready",
      dataIndex: "ready",
      key: "ready",
      sortFields: [ShipmentsSortField.PickUpReadyTime],
    },
    {
      title: "Deliver By",
      dataIndex: "deliverBy",
      key: "deliverBy",
      sortFields: [ShipmentsSortField.DropOffDueTime],
    },
    {
      title: "Driver",
      dataIndex: "driverName",
      key: "driverName",
      sortFields: [ShipmentsSortField.DriverName],
    },
    {
      title: "Package",
      dataIndex: "",
      key: "",
    },
    {
      title: "Reference",
      dataIndex: "endCustomerReferenceNumber",
      key: "endCustomerReferenceNumber",
    },
    {
      title: "",
      dataIndex: "menu",
      key: "menu",
    },
  ];
}
